export default __webpack_public_path__ + "static/media/token-logo.6bc1d313.ico";